<template>
	<div class="h-screen w-full bg-[#B9BECB] ">
		<div class="w-full bg-white h-[74px]">
			<examHeader :title="title"></examHeader>
			<div class="2xl:w-[1200px] xl:w-[1200px] lg:w-[1000px] mx-auto flex justify-between">
				<div class="lg:w-[700px] 2xl:w-[900px] xl:w-[900px] h-[78vh]  mr-[10px] flex flex-col overflow-hidden">
					<div :style="{ backgroundImage: svgWatermark1+watermarkContent+svgWatermark2}"
						class="w-full h-full overflow-y-auto  bg-repeat flex-1 shadow-01 rounded-[6px] mb-[10px] bg-white py-[30px] px-[16px] box-border">
						<div class="">
							<div class="flex  mb-[20px]">
								<el-tooltip class="item" effect="dark"
									:content="currentTopicInfo.is_user_collection==1?'取消收藏':'点击收藏'" placement="bottom">
									<img @click="collectClick()"
										:src="currentTopicInfo.is_user_collection==1?collectActive:collectImg"
										class="w-[24px] h-[24px] mr-[10px] cursor-pointer" alt="" srcset="" />
								</el-tooltip>
								<img @click="questionClick()"
									:src="currentTopicInfo.is_user_question==1?questionActive:questionImg"
									class="w-[24px] h-[24px] mr-[10px] cursor-pointer" alt="" srcset="" />

								<div class="flex-1 text-[18px] text-[#101010] font-semibold flex">
									{{currentTopic + 1 }}.<span v-html="currentTopicInfo.content"
										class="whitespace-pre-wrap"></span>
								</div>
							</div>
							<div class="pl-[68px] box-border text-[#101010]">
								<div @click="selectClick(item,index)" v-for="(item,index) in optionsList"
									class="flex items-center mb-[10px] cursor-pointer">
									<img :src="item.isSelect?selectedImg:selectImg"
										class="w-[14px] h-[14px] mr-[10px]" />
									<label class="mr-[14px] cursor-pointer">{{item.key}}.</label><label
										class="cursor-pointer" v-html="item.value"></label>
								</div>
							</div>
						</div>
					</div>
					<div class="shadow-01 rounded-[6px] h-[56px] bg-white flex items-center justify-center">
						<div @click="preTopic()" :class="currentTopic==0?'bg-[#8FC3FF]':'bg-[#2979FF] '"
							class="min-w-[100px] px-[10px] box-border h-[28px] leading-[28px] mr-[14px] text-center text-[14px] text-white rounded-[6px] cursor-pointer">
							{{langInfo.study_paper_answer_pre}}
						</div>
						<div @click="nextTopic()"
							:class="currentTopic==topicList.length - 1?'bg-[#8FC3FF]':'bg-[#2979FF]'"
							class="min-w-[100px] px-[10px] box-border h-[28px] leading-[28px] text-center text-white text-[14px] rounded-[6px] cursor-pointer">
							{{langInfo.study_paper_answer_next}}
						</div>
					</div>
				</div>
				<div class="flex-1">
					<div class="h-[68vh]  pb-[24px] box-border flex flex-col shadow-01 rounded-[6px]  bg-white">
						<div
							class="answerSheetTitle bB-01  p-[20px] box-border relative text-[16px] text-[#1B2128] font-bold">
							{{langInfo.study_paper_card}}
						</div>
						<div class="flex flex-wrap overflow-y-auto mb-[20px] py-[20px] px-[13px] box-border ">
							<div @click="selectTopic(item,index)"
								:class="[ item.userrecord && item.userrecord.user_answer?'bg-[#ff9000] text-white':'', currentTopic==index?'bg-[#A6A6A6] text-white':'']"
								class="topicItem mb-[10px] cursor-pointer relative   flex items-center justify-center box-border"
								v-for="(item,index) in topicList" :key="index">
								<img v-if="item.is_user_question==1&&item.is_user_collection==1" src="@/static/image/icon55.png"
									class="w-[14px] h-[14px] absolute top-[0px] right-[0px]" alt="" srcset="" />
								<img v-else-if="item.is_user_question==1" src="@/static/image/icon55.png"
									class="w-[14px] h-[14px] absolute bottom-[0px] right-[0px]" alt="" srcset="" />
									
								<img v-if="item.is_user_collection==1" :src="collectActive"
									class="w-[14px] h-[14px] cursor-pointer absolute bottom-[0px] right-[0px]" alt="" srcset="" />
								<label  class="cursor-pointer"> {{index + 1 }}</label>
							</div>
						</div>
						<div @click="handPaper()"
							class="bg-[#2979FF] w-[227px] h-[40px] leading-[40px] mx-auto text-center text-white rounded-[6px] cursor-pointer">
							{{langInfo.submit_test}}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import examHeader from '@/components/examHeader.vue'
	export default {
		components: {

			examHeader
		},
		data() {
			return {
				title: '',

				selectImg: require('@/static/image/icon37.png'),
				selectedImg: require('@/static/image/icon38.png'),


				collectActive: require('@/static/image/icon22Active.png'),
				collectImg: require('@/static/image/icon22.png'),

				questionActive: require('@/static/image/icon36Active.png'),
				questionImg: require('@/static/image/icon36.png'),

				optionsList: [],
				subjectId: '',
				// 当前题
				currentTopic: 0,
				currentTopicInfo: {
					id: '',
					title: '',
					isCollect: false,
					isQuestion: false,
				},
				// 题列表
				topicList: [],


				identification: '',
				type: '',

				langInfo: {},

				watermarkContent: JSON.parse(localStorage.getItem('userInfo')).username  + '@' + this.$common.currentTime()+'@港考通',
				svgWatermark1: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='140'><text x='0' y='100' transform='rotate(-30, 40, 100)' fill='%23999' font-size='14' opacity='0.2'>`,
				svgWatermark2: `</text></svg>")`,
			}
		},
		mounted() {
			this.subjectId = this.$route.query.subjectId
			this.type = 'is_sz'
			this.identification = this.$route.query.identification

			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			}
			this.getQuestionInfo()
		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj

					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			getQuestionInfo() {
				this.$api.getQuestionPaper({
					subjectId: this.subjectId,
					type: this.type,
					identification: this.identification
				}).then((res) => {
					console.log(res.data.data);
					this.title = res.data.chapter_name + "-" + this.langInfo.try_doing_questions
					this.questionInfo = res.data
					// is_user_collection=是否收藏0否1是
					res.data.data.forEach((item, index) => {
						console.log(item.is_user_question);

						item.options.forEach((itm, ind) => {
							this.$set(itm, 'isSelect', false)
						})
					})
					this.topicList = res.data.data

					console.log("this.topicList");
					console.log(this.topicList);


					this.getCurrentInfo()

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			getCurrentInfo() {
				this.currentTopicInfo = this.topicList[this.currentTopic]
				if (this.topicList[this.currentTopic].userrecord) {
					let userrecord = this.topicList[this.currentTopic].userrecord
					this.currentTopicInfo.options.forEach((item, index) => {
						this.$set(item,'isSelect',false)
						if (userrecord.user_answer == item.key) {
							item.isSelect = true
						}
					})
				}
				else{
					console.log("无");
					this.currentTopicInfo.options.forEach((item, index) => {
						this.$set(item,'isSelect',false)
					})
				}

				this.optionsList = this.currentTopicInfo.options
				console.log(this.optionsList);
				this.get_user_log()

			},
			get_user_log() {
				this.$api.user_log({
					action: 'question',
					type: 6,
					course_question_id: this.currentTopicInfo.id
				}).then((res) => {
					console.log(res);
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			selectClick(item, index) {
				this.optionsList.forEach((itm, ind) => {
					if (index == ind) {
						itm.isSelect = !itm.isSelect
					} else {
						itm.isSelect = false
					}
				})

				// question_paper_id=试卷id
				// course_question_id=题目id
				// user_answer=用户答案
				// mode=模式 模式:1=练习,2=错题,3=模拟考试  6试做
				// identification=试卷标识

				this.$api.recordQuestion({
					course_question_id: this.topicList[this.currentTopic].id,
					user_answer: item.isSelect ? item.key : '',
					mode: 6,
					identification: this.identification
				}).then((res) => {
					console.log(res);
					this.getAnsweredInfo()
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			getAnsweredInfo() {
				this.$api.getQuestionPaper({
					subjectId: this.subjectId,
					type: this.type,
					identification: this.identification
				}).then((res) => {
					console.log(res.data.data);
					// is_user_collection=是否收藏0否1是
					this.topicList = res.data.data
					console.log("this.topicList");
					console.log(this.topicList);

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})

			},
			// 上一页
			preTopic() {
				if (this.currentTopic == 0) {
					return
				}
				this.currentTopic--
				this.getCurrentInfo()
			},
			nextTopic() {
				if (this.currentTopic == this.topicList.length - 1) {
					return
				}
				this.currentTopic++
				this.getCurrentInfo()
			},
			selectTopic(item, index) {
				this.currentTopic = index;
				this.getCurrentInfo()
			},
			// 收藏
			collectClick() {
				console.log(12121);
				if (this.currentTopicInfo.is_user_collection == 1) {
					this.currentTopicInfo.is_user_collection = 0
				} else {
					this.currentTopicInfo.is_user_collection = 1
				}
				console.log(this.currentTopicInfo.is_user_collection);
				this.topicList[this.currentTopic].is_user_collection = this.currentTopicInfo.is_user_collection
				// type=类型:1=课程,2=咨询,3=资源,4=题目
				// course_course_id=课程id
				// course_question_id=题目id
				this.$api.addUserCollection({
					type: 4,
					course_question_id: this.currentTopicInfo.id
				}).then((res) => {
					console.log(res);
					// status=0 0是取消1是收藏成功
					if (res.data.status == 1) {
						this.$message({
							message: res.msg,
							type: 'success'
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'warning'
						})
					}

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			// 疑问标记
			questionClick() {
				if (this.currentTopicInfo.is_user_question == 1) {
					this.currentTopicInfo.is_user_question = 0
				} else {
					this.currentTopicInfo.is_user_question = 1
				}

				this.topicList[this.currentTopic].is_user_question = this.currentTopicInfo.is_user_question

				// type=类型:1=课程,2=咨询,3=资源,4=题目  5 疑问
				// course_course_id=课程id
				// course_question_id=题目id
				this.$api.addUserCollection({
					type: 5,
					course_question_id: this.currentTopicInfo.id
				}).then((res) => {
					console.log(res);
					// status=0 0是取消1是收藏成功、疑问
					if (res.data.status == 1) {
						this.$message({
							message: res.msg,
							type: 'success'
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'warning'
						})
					}

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},

			// 提交试卷
			handPaper() {
				console.log("提交试卷");

				this.$confirm(this.langInfo.phone_finish_paper_tip, this.langInfo.reg_tip, {
					confirmButtonText: this.langInfo.study_paper_confirm,
					cancelButtonText: this.langInfo.cancel,
					type: 'warning'
				}).then(() => {
					this.$api.updateExamStatus({
						action: 'complete',
						identification: this.identification
					}).then((res) => {
						this.$message({
							message: res.msg,
							type: 'success'
						})
						setTimeout(() => {
							this.$router.push({
								path: '/tryOutAnalysis',
								query: {
									id: res.data.id,
									identification: this.identification,
									type: this.type,
									subjectId: this.subjectId
								}
							})
						}, 800)
					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})
				}).catch(() => {

				});

			},

		}
	}
</script>

<style scoped>
	
	/deep/p img {
		width: 100% !important;
	}
	/* ::-webkit-scrollbar {
		display: none;
	} */

	.answerSheetTitle::after {
		content: '';
		position: absolute;
		width: 4px;
		height: 21px;
		background-color: rgba(103, 194, 58, 1);
		left: 0;
		top: 50%;
		transform: translateY(-50%);
	}

.topicItem:nth-child(5n) {
		margin-right: 0;
	
	}
	
	.topicItem {
		width: 18%;
		height: 30px;
		line-height: 30px;
		margin-right: 2.5%;
		border: 1px solid rgba(187, 187, 187, 1);
	}
</style>